import { render, staticRenderFns } from "./PortfoliosOverviewPage.vue?vue&type=template&id=b5462300&scoped=true&"
import script from "./PortfoliosOverviewPage.vue?vue&type=script&lang=js&"
export * from "./PortfoliosOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PortfoliosOverviewPage.vue?vue&type=style&index=0&id=b5462300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5462300",
  null
  
)

export default component.exports